// Owner: shell-nav (plan §9.2). The label of the search entry points (rail, phone menu): "Search or ask…"
// only where a question has somewhere to go (AI works for this member), else "Search…".
import { useAiAvailability } from '../ai/availability';
import { t } from '../lib/i18n';

export function useSearchLabel(): string {
  const ai = useAiAvailability('agent');
  return t(ai.ready ? 'shell.searchOrAsk' : 'shell.searchPlain');
}
